export default __webpack_public_path__ + "static/media/osusume.768102c1.png";